// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import {Logger} from '@app/features/platform/utils/AppLogger';
import type {
	OnboardingConfigResponse,
	OnboardingStatusResponse,
	OnboardingUpdateRequest,
} from '@fluxer/schema/src/domains/guild/OnboardingSchemas';

const logger = new Logger('OnboardingCommands');

export async function fetchOnboarding(guildId: string): Promise<OnboardingStatusResponse> {
	try {
		const response = await http.get<OnboardingStatusResponse>(Endpoints.GUILD_ONBOARDING(guildId));
		return response.body;
	} catch (error) {
		logger.error(`Failed to fetch onboarding for guild ${guildId}:`, error);
		throw error;
	}
}

export async function updateOnboarding(
	guildId: string,
	data: OnboardingUpdateRequest,
): Promise<OnboardingConfigResponse> {
	try {
		const response = await http.put<OnboardingConfigResponse>(Endpoints.GUILD_ONBOARDING(guildId), {body: data});
		return response.body;
	} catch (error) {
		logger.error(`Failed to update onboarding for guild ${guildId}:`, error);
		throw error;
	}
}

export async function acceptRules(guildId: string): Promise<void> {
	try {
		await http.post(Endpoints.GUILD_ONBOARDING_ACCEPT_RULES(guildId), {body: {}});
	} catch (error) {
		logger.error(`Failed to accept rules for guild ${guildId}:`, error);
		throw error;
	}
}

export async function markWelcomeSeen(guildId: string): Promise<void> {
	try {
		await http.post(Endpoints.GUILD_ONBOARDING_WELCOME_SEEN(guildId), {body: {}});
	} catch (error) {
		logger.error(`Failed to mark the welcome screen as seen for guild ${guildId}:`, error);
	}
}
